/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_polygon_address_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Dirección copiada al portapapeles`
};

const en_accounts_polygon_address_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Address copied to clipboard`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_polygon_address_copied = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_polygon_address_copied(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_polygon_address_copied", locale)
	if (locale === "es") return es_accounts_polygon_address_copied(inputs)
	return en_accounts_polygon_address_copied(inputs)
};
export { accounts_polygon_address_copied as "accounts.polygon.address_copied" }